import { Navigate } from 'react-router';
import { useEffect } from 'react';

import { chainsRoutesConfig } from 'domains/chains/routes';
import { resetIsSignedOutManually } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';

const chainsPath = chainsRoutesConfig.chains.generatePath();

export const RedirectToChainsList = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetIsSignedOutManually());
  }, [dispatch]);

  return <Navigate to={chainsPath} />;
};
